import request from '../request';

const AttendanceList = '/triascloud-iot-smart-helmet/device/position';

/**
 * @name 考勤记录
 */
export function getTrace(body) {
  return request(AttendanceList, {
    method: 'GET',
    body: body,
    closeMessage: true,
  });
}
export function getDivceProject(deviceId) {
  return request(`${AttendanceList}/topParam/${deviceId}`, {
    method: 'GET',
    closeMessage: true,
  });
}
